<template>
    <div id="assistance-frame" ref="assistance-frame">
        <div class="container is-max-desktop auth-card columns">

            <div class="column left-side">
                <h1>
                    <strong>my</strong>247ed.com<span class="beta">BETA</span>
                </h1>

                <hr/>

                <section class="content mt-3">
                    <div class="columns is-mobile">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-key"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Try a Different Login Method</h6>

                            <p>To login you can provide either an e-mail address or phone number.  If we find your account there may be several methods available to log you in.  For example, you can have a code sent to your e-mail account (hit <strong>"Login with your E-Mail")</strong> or text-message capable phone number (hit <strong>"Login with your Phone"</strong>) associated to your account.</p>
                            <p class="mb-5"><i class="far fa-info-circle mr-2"></i><strong>Tip:</strong> Once logged in you can change your password or other account information.</p>

                            <div class="has-text-right">
                                <b-button tag="router-link" type="is-primary" to="/" icon-left="arrow-left">Try Again</b-button>
                            </div>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns is-mobile">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-lock-keyhole"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Did you forget your password?</h6>

                            <p class="mb-5">Please provide us with your e-mail address. If it's a valid account, we'll send you an e-mail with a link to reset your password. Be sure to check your spam/junk folders!</p>

                            <b-field label-position="inside">
                                <template #label>E-Mail Address <span class="required-flag">*</span></template>
                                <b-input v-model="resetEmail"></b-input>
                            </b-field>

                            <div class="has-text-right">
                                <b-button type="is-primary" icon-left="envelope" @click="resetPassword">Reset Password</b-button>
                            </div>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns is-mobile">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-id-card"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Maybe you don't actually have an account?</h6>

                            <p class="mb-5"><strong><span style="color: #336699;">my</span>247ed.com</strong> provides online courses for other organizations. Those specific organization's logins are not the same and will not work here. If you feel this is the case then please sign up!</p>

                            <div class="has-text-right">
                                <b-button tag="router-link" type="is-primary" to="/signup" icon-left="user-plus">Sign Up</b-button>
                            </div>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns is-mobile">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-messages-question"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Need further assistance?</h6>

                            <p class="mb-5">If you are still having problems gaining access please feel free to reach out to us and we'll get you sorted out!</p>

                            <div class="has-text-right">
                                <a href="mailto:support@my247ed.com?subject=Login%20Assistance">
                                    <b-button type="is-primary" icon-left="messages-question">Get Help</b-button>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        </div>
    </div>
</template>

<script>
    import {client as http} from "../http_client";
    import {mapActions, mapGetters} from "vuex";
    import UiCard from "../components/UiCard";

    export default {
        name: 'login',
        components: {UiCard},
        data: function() {
            return {
                processing: false,
                resetEmail: '',
            };
        },
        methods: {
            ...mapActions(['login']),
            resetPassword() {
                if (!this.processing) {
                    this.processing = true;
                    http.post('app/users/reset', {email: this.resetEmail}, {force: true}).then(response => {
                        this.$router.push('/');
                        this.$notify('success', 'Password Reset', 'Please check your email for password reset instructions.', {duration: 10000, permanent: true});
                    }).catch(err => {
                        if (err) console.log(err.response);
                        if (err.response.status === 404) {
                            window.alert('No valid account was found.  Check your e-mail address for errors or sign-up.');
                        } else {
                            window.alert('An error occurred. If you need additional help please contact us at support@my247ed.com.');
                        }
                        this.processing = false;
                    });
                }
            },
        },
        mounted() {

        }
    };
</script>

<style lang="scss">
    #assistance-frame {
        display: flex;
        min-height: 100vh;
        align-items: center;
        justify-content: center;
        background: #224C74 radial-gradient(#336699, #1e385c);

        .auth-card {
            margin: 4rem 2rem 8rem;
            border-radius: 8px;
            box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);

            .left-side {
                background-color: #FFFFFF;
                padding: 4rem 3.5rem 4rem 3.5rem;
                border-radius: 5px;
                color: #666666;

                strong {
                    color: #484848;
                }

                h1 {
                    font-weight: normal;
                    font-size: 2.6rem !important;
                    color: #282828;
                    margin-bottom: 1.5rem;
                    letter-spacing: -1px;

                    strong {
                        color: #336699;
                        font-weight: 900;
                    }

                    @media (max-width: 768px) {
                        font-size: 2.2rem !important;
                        margin-bottom: 1rem;
                    }
                }

                > p {
                    font-size: 1.2rem;
                    line-height: 1.7rem;
                }

                .is-size-7 {
                    font-size: 0.85rem !important;
                }

                .signup {
                    border-top: 1px solid #e9e9e9;
                    padding-top: 1.5rem;
                    margin-top: 4rem;

                    .button {
                        padding-left: 1.3rem;
                    }

                    @media (max-width: 768px) {
                        margin-top: 2rem;
                    }
                }

                @media (max-width: 768px) {
                    border-radius: 5px;
                    padding: 3rem 1rem 2.5rem 1rem;
                    box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
                }
            }


            h4 {
                font-size: 1.2rem;
                margin-top: 1.5rem;
                margin-bottom: 2rem;
                padding-bottom: 0.8rem;

                i {
                    color: #336699;
                }

                border-bottom: 1px dashed #ddd;
            }

            @media (max-width: 768px) {
                margin: 1rem;
                box-shadow: none;
            }
        }


        @media (max-width: 768px) {
            align-items: normal;
            justify-content: normal;
        }

        span {
            &.beta {
                color: #333;
                border: 1px solid #c2c2c2;
                border-radius: 3px;
                padding: 0 4px;
                font-size: 0.6rem;
                margin-left: 0.5rem;
                vertical-align: super;
                font-weight: normal;
                letter-spacing: normal;
            }
        }
    }

    .required-flag {
        color: red;
    }
</style>
